/** @format */

import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";

import { useApi } from "../../Hooks/Api";
import { useToast } from "../../Hooks/Toast";
import { getApiUrl } from "../../Utils/Helpers";
import ErrorMessage from "../Errors/ErrorMessage";

//add plugin to image upload filePond library
registerPlugin(
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize
);

const FileUploader = ({
  title,
  name,
  fileUploadName = "file",
  allowMultiple = true,
  maxFiles = 3,
  maxFileSize,
  serverUrl,
  method,
  headers = {},
  required = false,
  roles,
  serverError,
  setLoading = (value) => {},
}) => {
  const { destroy } = useApi();
  const { success, error } = useToast();
  // const [files, setFiles] = useState([]);
  const { errors, values, setFieldValue } = useFormikContext();
  return (
    <div className='d-flex flex-column'>
      <label className='f-13 text-dark text-left d-flex flex-row justify-content-start'>
        {title}
      </label>
      <FilePond
        className='f-14'
        files={values[name]}
        onupdatefiles={(fileItems) => {
          setFieldValue(name, fileItems, true);
        }}
        onprocessfile={() => {
          setLoading(false);
        }}
        oninit={() => {
          setLoading(true);
        }}
        allowMultiple={allowMultiple}
        maxFiles={maxFiles}
        maxFileSize={maxFileSize}
        labelMaxFileSizeExceeded={`باشد (${maxFileSize}) حجم تصویر نباید بیشتر از`}
        name={fileUploadName}
        acceptedFileTypes={roles}
        labelFileTypeNotAllowed={`باشد ${roles.toString()} فرمت فایل باید `}
        server={{
          process: {
            url: getApiUrl() + serverUrl,
            method: method,
          },
          revert: async (file) => {
            let data = JSON.parse(file);
            await destroy(
              `/file/`,
              { photo: data.data.path },
              (res) => {
                setFieldValue(name, [], true);
                success("تصویر با موفقیت حذف شد");
              },
              (err) => {
                error("حذف تصویر ناموفق بود");
              }
            );
          },
          headers: { Accept: "application/json", headers },
        }}
        labelIdle='<p className="border border-info p-2 font-family-num-fa f-14 text-secondary"><span class="filepond--label-action font-family-num-fa f-14 text-info d-inline-block">انتخاب کنید</span> فایل را اینجا رها کنید و یا</p>'
      />
      <ErrorMessage error={errors[name] ? errors[name] : serverError} />
    </div>
  );
};

Text.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  fileUploadName: PropTypes.string,
  allowMultiple: PropTypes.bool,
  maxFiles: PropTypes.number,
  maxFileSize: PropTypes.string,
  serverUrl: PropTypes.string.isRequired,
  method: PropTypes.string.isRequired,
  headers: PropTypes.object,
  required: PropTypes.bool,
  roles: PropTypes.array,
  serverError: PropTypes.string,
};
export default FileUploader;
